import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  resources: [],
  error: "",
};

const freeResourceSlice = createSlice({
  name: "freeResource",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true;
    },
    getResourcesSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.resources = payload;
      state.error = "";
    },
    getResourcesFail: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    getSingleResourceSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.selectedResource = payload;
      state.error = "";
    },
  },
});

const { reducer, actions } = freeResourceSlice;
export const {
  isPending,
  getResourcesSuccess,
  getResourcesFail,
  getSingleResourceSuccess,
} = actions;

export default reducer;
